import logo from '../../../dashboard/assets/logo.png';

/** Shared split layout for all auth screens. */
export function AuthLayout({
  children,
  right,
  rightImage,
  rightAlt = 'Aexon',
  leftClassName = '',
  rightClassName = '',
}) {
  return (
    <div className="h-screen w-full overflow-y-auto no-scrollbar font-sf-pro-display">
      <div className="min-h-full w-full grid grid-cols-1 lg:grid-cols-2">
        <section
          className={`bg-surface-mint-soft flex items-start justify-center px-4 md:px-8 lg:px-12 xl:px-16 py-12 ${leftClassName}`}
        >
          <div className="w-full max-w-[710px] mx-auto lg:mr-auto flex flex-col text-left pt-4 lg:pt-8">
            <img
              src={logo}
              alt="Aexon Logo"
              className="h-12 w-auto mb-8 lg:hidden self-start object-contain scale-[1.35] origin-left"
            />
            {children}
          </div>
        </section>

        <section
          className={`bg-surface-mint-deep hidden lg:flex sticky top-0 h-screen items-center justify-center px-8 xl:px-16 relative overflow-hidden ${rightClassName}`}
        >
          {right ??
            (rightImage ? (
              <div className="relative w-full max-w-[558px] h-[750px] aspect-square flex items-center justify-center">
                <img
                  src={rightImage}
                  alt={rightAlt}
                  className="w-full h-full object-contain select-none z-10"
                />
              </div>
            ) : null)}
        </section>
      </div>
    </div>
  );
}
